import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]


export default /*#__PURE__*/_defineComponent({
  __name: 'DataTableHeader',
  props: {
  columns: {
    type: Object,
    require: true
  },
  toggleSort: {
    type: Function,
    require: true
  },
  isSorted: {
    type: Function,
    require: true
  },
  getSortIcon: {
    type: Function,
    require: true
  }
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("tr", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column) => {
      return (_openBlock(), _createElementBlock("td", {
        key: column.key
      }, [
        _createElementVNode("span", {
          class: "mr-2 cursor-pointer",
          onClick: () => props.toggleSort?.(column)
        }, _toDisplayString(column.title.length > 0 ? _ctx.$t(column.title) : ''), 9, _hoisted_1),
        (props.isSorted?.(column))
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              size: "small",
              icon: props.getSortIcon?.(column)
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})